import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { Construction } from '@mui/icons-material';

export default function DesignerDemo() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
      }}
    >
      <Card sx={{ maxWidth: 500, textAlign: 'center', p: 4 }}>
        <CardContent>
          <Construction sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" gutterBottom fontWeight="bold">
            Coming Soon
          </Typography>
          <Typography variant="body1" color="textSecondary">
            The Designer Demo feature is currently under construction.
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Check back later for updates!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
